import { render, staticRenderFns } from "./NewsH2.vue?vue&type=template&id=4cd2d26e"
import script from "./NewsH2.vue?vue&type=script&lang=js"
export * from "./NewsH2.vue?vue&type=script&lang=js"
import style0 from "./NewsH2.vue?vue&type=style&index=0&id=4cd2d26e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports